module.exports = __webpack_public_path__ + "static/img/delete1.df5e7ce9.png";